import React, { useState } from "react";
import "./index.less";

// 导入图片资源
import harmanLogoImg from "../../public/images/harman-logo.png";
import topEmployerChinaImg from "../../public/images/top-employer-china-2026.png";

export default (props) => {
  const { setActiveIndex } = props;
  const [activeNavBarIndex, setNavbarIndex] = useState(0);
  const handleClick = (index) => {
    setNavbarIndex(index);
    setActiveIndex(index);
  };
  const isEqual = (val1, val2) => {
    return String(val1) === String(val2);
  };
  return (
    <>
      <div className="navbar">
        <div className="block_1">
          <img className="image_1" alt="" src={harmanLogoImg} />
          {isEqual(activeNavBarIndex, 0) ? (
            <div className="box_18" onClick={() => handleClick(0)}>
              <span className="text_1 active">首页</span>
              <div className="box_1"></div>
            </div>
          ) : (
            <span className="text_1" onClick={() => handleClick(0)}>
              首页
            </span>
          )}

          {isEqual(activeNavBarIndex, 1) ? (
            <div className="box_23" onClick={() => handleClick(1)}>
              <span className="text_2">工作在哈曼</span>
              <div className="section_1 flex-col"></div>
            </div>
          ) : (
            <span className="text_2" onClick={() => handleClick(1)}>
              工作在哈曼
            </span>
          )}

          {isEqual(activeNavBarIndex, 2) ? (
            <div className="box_34" onClick={() => handleClick(2)}>
              <span className="text_3">社会招聘</span>
              <div className="section_1"></div>
            </div>
          ) : (
            <span className="text_3" onClick={() => handleClick(2)}>
              社会招聘
            </span>
          )}

          {/* <span className="text_4">
            <a
              href="https://jobs.harman.com/china-chi"
              target="_blank"
              rel="noreferrer"
            >
              校园招聘
            </a>
          </span> */}
          <span className="text_5">
            {/*<a href="https://jobsearch.oneharman.cn/zh_CN/careers" target="_blank" rel="noreferrer">*/}
            {/*  哈曼求职网站*/}
            {/*</a>*/}
             <a href="https://jobs.harman.com/china" target="_blank" rel="noreferrer">
              哈曼求职网站
            </a>

          </span>
          <img
              className="image_2"
              alt=""
              src={topEmployerChinaImg}
          />
        </div>
      </div>
    </>
  );
};
